import React, { useEffect } from 'react'
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import './CreateMenuGroup.scss';
import { support_language, translation } from '../../../../Utils/services';
import { useSelector } from 'react-redux';
import { languageInit, onTranslation } from '../../../../Utils/functions';
import CheckLanguage from '../../../../Components/HotelOrder/CheckLanguage';

const CreateMenuGroup = ({createMenuGroup}) => {
    const [ name, setName ] = React.useState(languageInit())
    const [ desc, setDesc ] = React.useState(languageInit())
    const language = useSelector(state => state.tableorder.language);

    const post = () => {
        createMenuGroup({
            Name : {...name},
            Description : {...desc}
        })
    };

    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko, desc.ko];
        const trans_value = ['name', 'desc'];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
        setDesc({...data.desc});
    };

    return (
        <div>
            <div className='row'>
                <p className='label' style={{flex: 1}}>메뉴그룹명</p>
                <Input
                    value={name.ko}
                    onChange={(e) => setName({...name, ko: e.target.value})}
                    style={{ width : 247 }}
                    placeholder="예) 메인메뉴, 세트메뉴 등"
                />
            </div>
            <CheckLanguage>
                <div className='btn-row' style={{alignItems: 'center', marginTop:16}}>
                    <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                    <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                        자동번역
                    </Button>
                </div>

                {support_language.map((item, index) => {
                    if(item.value && language[item.value]) {
                        return(
                            <React.Fragment key={index}>
                                <div className='divider' style={{margin: '16px 0'}} />
                                <p className='title' style={{marginBottom:8}}>{item.text}</p>
                                <div className='row'>
                                    <p className='label' style={{flex: 1}}>메뉴그룹명</p>
                                    <Input
                                        value={name[item.value]}
                                        onChange={(e) => setName({...name, [item.value]: e.target.value})}
                                        style={{ width : 247 }}
                                        placeholder="예) 메인메뉴, 세트메뉴 등"
                                    />
                                </div>
                            </React.Fragment>
                        );
                    }
                })}
            </CheckLanguage>

            {/* <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                <p className='label'>설명(선택)</p>
                <Textarea
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                    style={{ width : 347, height : 173 }}
                    placeholder="예) 세트 구성 메뉴입니다."
                />
            </div> */}

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => post()} disabled={name.ko === '' || typeof name.ko === 'undefined'}>
                    추가하기
                </Button>
            </div>
        </div>
    )
}

export default CreateMenuGroup;